import React from 'react';
import PropTypes from 'prop-types';
import SectionHeader from '../SectionHeader';
import EventCard from '../EventCard';
import EventCardSkeleton from '../EventCardSkeleton';
import ScrollControls from '../../../../../components/ScrollControls/ScrollControls';
import css from './EventsSection.module.css';

const SKELETON_COUNT = 5;

const EventsSection = ({
  title,
  events,
  onEventClick,
  user = null,
  showScrollControls = false,
  showCrewInfo = false,
  scrollRef = null,
  keyPrefix = 'event',
  showSmartIcon = false,
  loading = false,
  iconSrc = null,
  iconAlt = '',
  iconAsMask = false,
  iconSize = 26,
  smartIconColor = null,
  eventCardVariant = 'landing',
  eventCardTheme = 'dark',
}) => {
  return (
    <section className={css.section}>
      <SectionHeader
        title={title}
        user={user}
        showSmartIcon={showSmartIcon}
        iconSrc={iconSrc}
        iconAlt={iconAlt}
        iconAsMask={iconAsMask}
        iconSize={iconSize}
        smartIconColor={smartIconColor}
      />
      {showScrollControls && scrollRef && (
        <div className={css.scrollControlsContainer}>
          <ScrollControls containerRef={scrollRef} theme="dark" />
        </div>
      )}
      <div ref={scrollRef} className={css.eventsGrid}>
        {loading
          ? Array.from({ length: SKELETON_COUNT }, (_, i) => (
              <EventCardSkeleton key={`${keyPrefix}-skeleton-${i}`} />
            ))
          : events.map((event, index) => (
              <EventCard
                key={`${keyPrefix}-${event.id || 'event'}-${index}`}
                event={event}
                showCrewInfo={showCrewInfo}
                onClick={onEventClick}
                variant={eventCardVariant}
                theme={eventCardTheme}
              />
            ))}
      </div>
    </section>
  );
};

EventsSection.propTypes = {
  title: PropTypes.string.isRequired,
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEventClick: PropTypes.func.isRequired,
  user: PropTypes.object,
  showScrollControls: PropTypes.bool,
  showCrewInfo: PropTypes.bool,
  scrollRef: PropTypes.object,
  keyPrefix: PropTypes.string,
  showSmartIcon: PropTypes.bool,
  loading: PropTypes.bool,
  iconSrc: PropTypes.string,
  iconAlt: PropTypes.string,
  iconAsMask: PropTypes.bool,
  iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  smartIconColor: PropTypes.string,
  eventCardVariant: PropTypes.string,
  eventCardTheme: PropTypes.oneOf(['light', 'dark']),
};

export default EventsSection;
